<template>
  <div>
     <form v-on:submit.prevent="onSubmit" class="form-inline">
       <label class="mr-sm-2" for="year">Year</label>
       <input @change="set()" id="year" class="form-control mr-sm-2" v-model="variables.year" type="number">
     </form>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "global-variables",
  computed: mapState(["variables"]),
  methods: {
    set() {
      this.$store.dispatch("setVariables", this.variables);
    }
  },
  mounted: function() {
    this.$store.dispatch("loadVariables");
  }
};
</script>
